import React from "react";
import _ from "lodash";
import moment from "moment";
import { withTranslation } from "react-i18next";
import sortPrograms from "../../../utils/sort-programs";
import { filterByPath as filterByPath } from "../../../utils/array-helpers";
import { filterCyclesByPath as filterCyclesByPath } from "../../../utils/array-helpers";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import LibraryProgramCard from "../../../parts/cards/library-program-card";
import LibraryCycleCard from "../../../parts/cards/library-cycle-card";
import ProgramFilters from "../../../parts/filters/program-library-programs";
import AddToCalendarModal from "../../../parts/modals/add-to-calendar";
import SuggestUpgradeModal from "../../../parts/modals/suggest-upgrade";
import LearnMoreModal from "../../../parts/modals/learn-more";
import Pagination from "../../../parts/pagination";
import Select from "../../../parts/inputs/select";
import DropdownIconsCheck from "../../../parts/inputs/dropdown-icons-check";
import submit from "submit-form";
import { RillContext } from "../../../rill/RillReact/share/base";

const pageSize = 50;

class View extends React.Component {
  render() {
    const { locals } = this.context;
    const { t } = this.props;
    const isProgramView = locals.query["program-view"] === "programs";
    const sortItems = [
      {
        title: t("programLibrary.datePublished"),
        id: "createdDate",
      },
      {
        title: t("programLibrary.nameAscending"),
        id: "name",
      },
      {
        title: t("programLibrary.nameDescending"),
        id: "nameDescending",
      },
    ];
    return (
      <main className="athlete-programs">
        <input type="checkbox" id="mobile-filter-toggle" />
        <header>
          <div>
            <DropdownIconsCheck
              items={sortItems}
              action={(sort) => {
                submit(`/actions/refresh`, {
                  method: "GET",
                  body: { sort },
                });
              }}
              title={t("programBuilder.sort")}
              alignRight={true}
            />
          </div>
        </header>
        {/* <ProgramFilters query={locals.query} locals={locals} /> */}

        <section className="Content">
          <div className="columns">
            {isProgramView
              ? _.map(locals.cards, (program, cardIndex) => (
                  <LibraryProgramCard
                    program={program}
                    cardIndex={cardIndex}
                    referrer="program-library"
                  />
                ))
              : _.map(locals.cards, (cycle, cardIndex) => (
                  <LibraryCycleCard
                    cycle={cycle}
                    cardIndex={cardIndex}
                    isOwnCycle={cycle.owner === locals.user._id}
                  />
                ))}
          </div>
          <Pagination total={this.props.total} pageSize={pageSize} />
          {/* <div className="Program-List">
            <div className="head">
              <div className="left-side">
                <div className="top">
                  <ToggleLinksInput
                    name="program-type"
                    options={[
                      { text: "All", value: "all" },
                      { text: "Premium", value: "premium" },
                      { text: "Standard", value: "standard" },
                    ]}
                  />
                </div>
              </div>

              <div className="right-side">
                <div className="top">
                  <select
                    className="select-input"
                    defaultValue={`${locals.query.sort}`}
                    onChange={(e) => {
                      window.location.href = `/actions/refresh?sort=${e.target.value}`;
                    }}
                  >
                    <option>Sort</option>
                    <option value="createdDate">Date Published</option>
                    <option value="name">Name Ascending</option>
                    <option value="nameDescending">Name Descending</option>
                  </select>
                  <DropdownIconsCheck
                    items={sortItems}
                    action={(sort) => {
                      submit(`/actions/refresh`, {
                        method: "GET",
                        body: { sort },
                      });
                    }}
                    title="Sort"
                  />
                </div>
              </div>
            </div>

            

            
          </div> */}
        </section>
      </main>
    );
  }
}

View.contextType = RillContext;

const ViewWithI18n = withTranslation("dashboard")(View);

const ProgramLibrary = (app) => {
  app.get("/", async ({ res, req, load, locals, api }) => {
    const { query } = req;
    const page = query.page - 1 || 0;

    await load("libraryCycles", {
      customSkip: pageSize * page,
      customLimit: pageSize,
    });
    await load("libraryCyclesCount");

    // setup cards based on whether program or cycle view is selected.
    // const cards = getCards({ cardType: query["program-view"], cycles: locals.libraryCycles, programType: query["program-type"] })

    // filters sorted programs / cycles
    // Note: `sortPrograms` compose `getCards` which returns cards based on view selected i.e extracts program cards from cycle when program view is selected
    const sortedCards = sortPrograms(
      locals.libraryCycles,
      query.sort,
      query["program-type"],
      query["program-progress"],
      query["program-view"],
      null,
      query["filters"]
    );

    locals.cards =
      query["program-view"] === "programs"
        ? filterByPath(sortedCards, query.filters)
        : filterCyclesByPath(sortedCards, query.filters);

    // puts a unique array of all coaches in locals.
    locals.coaches = _.uniqBy(
      _.map(locals.libraryCycles, (cycle) => cycle.createdBy),
      "_id"
    );

    const modal = _.get(query, "modal", {});

    if (modal.type === "add-to-calendar") {
      await load("activeExercises", {
        start: moment(-1),
        end: moment("December 30 2049"),
      });
      locals.editCycle = locals.libraryCycles.find(
        (cycle) => cycle._id === query.cycleId
      );
    } else if (modal.type === "learn-more") {
      locals.editCycle = locals.libraryCycles.find(
        (cycle) => cycle._id === query.cycleId
      );
      await load("programExercises", { programId: query.cycleId });
    }

    locals.modal = {
      "add-to-calendar": <AddToCalendarModal />,
      "suggest-upgrade": <SuggestUpgradeModal api={api} />,
      "learn-more": <LearnMoreModal fromAthlete />,
    }[modal.type];

    res.body = <ViewWithI18n total={locals.libraryCyclesCount.count} />;
  });
};

export default ProgramLibrary;
